import React from 'react';
import '../Css/UserRegister.css';

const AdminRegistration = () => {
  return (
    <></>
  );
};

export default AdminRegistration;

